<template>
    <div class="pt-15 animated fadeIn equipmentList bgV2">
        <div class="boxShadow setBorderRadius heig-frame-equipment-group">
            <b-row no-gutters>
                <b-col md="12" class="heig-frame-child">
                    <defects/>
                </b-col>
            </b-row>
        </div>
    </div>
</template>
<script>
    const Defects = () => import('../list.vue')
    export default {
        name: "defect-report-supplier",
        components: {
            Defects
        }
    }
</script>